<script>
    import * as animateScroll from "svelte-scrollto";
    import { onMount } from 'svelte';
    export let subSelection;
	
    onMount(async () => {
        if(subSelection == 0)  animateScroll.scrollToTop();
        else animateScroll.scrollTo({element: '#about-section-' + subSelection, offset: -80});
        
    });

    let open = 0;

    let handleClickAboutCardOne = () => {

        if( open != 1){
            open = 1;
        }else{
            open = 0;
        }
        
    }
    let handleClickAboutCardTwo = () => {
        if( open != 2){
            open = 2;
        }else{
            open = 0;
        }
    }
    let handleClickAboutCardThree = () => {
        if( open != 3){
            open = 3;
        }else{
            open = 0;
        }
    }

    let y, innerHeight;
    let row1, row1Image, calculatedRow1Start, translate1Calculated, conditionRow1;
    let row2, row2Image, calculatedRow2Start, translate2Calculated, conditionRow2;
    let row3, row3Image, calculatedRow3Start, translate3Calculated, conditionRow3;
    let row4, row4Image, calculatedRow4Start, translate4Calculated, conditionRow4;

    $: if (y) {
        calculatedRow1Start = row1.getBoundingClientRect().y - innerHeight/2;
        conditionRow1 = row1Image.getBoundingClientRect().width*0.34 + calculatedRow1Start > 0;
        translate1Calculated = conditionRow1 ? Math.pow(row1Image.getBoundingClientRect().width*0.34 + calculatedRow1Start, 2) : 0;

        calculatedRow2Start = row2.getBoundingClientRect().y - innerHeight/2;
        conditionRow2 = row2Image.getBoundingClientRect().width*0.3 + calculatedRow2Start > 0;
        translate2Calculated = conditionRow2 ? Math.pow(row2Image.getBoundingClientRect().width*0.3 + calculatedRow2Start, 2) : 0;

        calculatedRow3Start = row3.getBoundingClientRect().y - innerHeight/2;
        conditionRow3 = row3Image.getBoundingClientRect().width*0.34 + calculatedRow3Start > 0;
        translate3Calculated = conditionRow3 ? Math.pow(row3Image.getBoundingClientRect().width*0.34 + calculatedRow3Start, 2) : 0;

        calculatedRow4Start = row4.getBoundingClientRect().y - innerHeight/2;
        conditionRow4 = row4Image.getBoundingClientRect().width*0.34 + calculatedRow4Start > 0;
        translate4Calculated = conditionRow4 ? Math.pow(row4Image.getBoundingClientRect().width*0.34 + calculatedRow4Start, 2) : 0;
    }

    import Icon from 'fa-svelte';
    import { faSortUp } from '@fortawesome/free-solid-svg-icons/faSortUp';
    import { faSortDown } from '@fortawesome/free-solid-svg-icons/faSortDown';

    let up1 = true;
    let up2 = true;
    let up3 = true;
    let up4 = true;
    let up5 = true;

    let handleClickArrow1 = () => {
        up1 = !up1;
        up2 = true;
        up3 = true;
    }
    let handleClickArrow2 = () => {
        up2 = !up2;
        up1 = true;
        up3 = true;
    }
    let handleClickArrow3 = () => {
        up3 = !up3;
        up1 = true;
        up2 = true;
    }
    let handleClickArrow4 = () => {
        up4 = !up4;
        up5 = true;
    }
    let handleClickArrow5 = () => {
        up5 = !up5;
        up4 = true;
    }



</script>

<svelte:window bind:scrollY={y} bind:innerHeight={innerHeight}/>

<div class="row">
    <div class="col-12 white-bg" style="overflow:hidden" bind:this={row1}>
        <img src="./img/background-A.svg" alt="" class="background-right disabe-img">
        <div class="row">
            <img bind:this={row1Image} class="about-base01-tree disabe-img" src="./img/about/recorte-arbol2.png" alt="" style="{row1Image ? `transform: translateX(${-translate1Calculated/2000}px)` : ''}">
            <img class="about-base01-icon disabe-img" src="./img/about/icono1-mundo1-A.svg" alt="" style="{row1Image ? `transform: translateX(${translate1Calculated/2000}px)` : ''}">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <h2 class="text-content title-content" style="margin: 20px 0 0 0;"> DEFINICIÓN Y OBJETIVO </h2>
                <hr class="underline-content">
            </div>
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <p class="text-content text-width-5">
                    La Certificación de Vivienda Sustentable CVS es un
                    sistema voluntario de certificación ambiental que
                    evalúa el desempeño de los proyectos residenciales a
                    nivel nacional. Es aplicable a cualquier tipo de vivienda
                    nueva, ya sea pública o privada, y busca incentivar la
                    mejora de la calidad, a través de la verificación de la
                    correcta implementación de buenas prácticas de
                    diseño y construcción, que permiten, entre otras
                    ventajas, reducir los costos de operación y
                    mantenimiento de los hogares, cuidar el medio
                    ambiente, y mejorar la calidad de vida de las personas. <br> <br>
                    Mediante la CVS se espera mejorar, de manera
                    continua y permanente, el estándar de construcción de
                    viviendas a nivel nacional, promoviendo criterios de
                    sustentabilidad, e impulsando la transformación del
                    mercado de la construcción, hacia uno de orden más
                    sostenible en toda su cadena de valor.
                </p>
            </div>
        </div>
    </div>
    <div class="col-12 white-bg" style="overflow:hidden" bind:this={row2} id="about-section-1">
        <img src="./img/background-B.svg" alt="" class="background-left disabe-img">
        <div class="row">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <h2 class="text-content title-content section-cvs" style="margin-bottom:0"> ¿QUÉ TIPOS DE VIVIENDAS SE CERTIFICAN? </h2>
                <hr class="underline-content">
            </div>
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <p class="text-content text-width-5">
                    Se puede aplicar indistintamente en viviendas nuevas,
                    que respondan a cualquiera de las siguientes
                    características:
                </p>
            </div>
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 text-align padding-fix">
                <div class="certification-icon-container">
                    <img class="icon-size" src="./img/icon1-A.svg" alt="">
                    <img class="icon-size" src="./img/icon2-A.svg" alt="">
                    <img class="icon-size" src="./img/icon3-A.svg" alt="">
                    <img class="icon-size" src="./img/icon4-A.svg" alt="">
                    <img class="icon-size" src="./img/icon5-A.svg" alt="">
                </div>
            </div>
            <img bind:this={row2Image} src="./img/about/techo.png" alt="" class="about-base02-rooftop disabe-img" style="{row2Image ? `transform: translateY(${translate2Calculated/2000}px)` : ''}">
        </div>
    </div>
    <div class="col-12 white-bg" style="overflow:hidden" bind:this={row3} id="about-section-2">
        <img src="./img/background-C.svg" alt="" class="background-right disabe-img">
        <div class="row">
            <img bind:this={row3Image} class="about-base03-house disabe-img" src="./img/about/casa-sustentable.png" alt="" style="{row3Image ? `transform: translateY(${translate3Calculated/2000}px)` : ''}">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 text-width-5 padding-fix">
                <h2 class="text-content title-content" style="margin-bottom:0"> CARACTERÍSTICAS DE UNA VIVIENDA SUSTENTABLE </h2>
                <hr class="underline-content">
            </div>
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-4 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <p class="text-content">
                    Las viviendas certificadas tienen un estándar de
                    sustentabilidad superior al promedio del mercado o a
                    lo que exigen los instrumentos regulatorios. Son
                    construcciones de alto desempeño ambiental y
                    energético. Eso significa que son viviendas que
                    destacan en los siguientes aspectos:
                </p>
                <ul class="list-content" style="margin-bottom:5vh;">
                    <li>Calidad del aire</li>
                    <li>Temperatura confortable</li>
                    <li>Iluminación natural</li>
                    <li>Sistemas de climatización eficientes</li>
                    <li>Sellos contra infiltraciones</li>
                    <li>Artefactos sanitarios eficientes</li>
                    <li>Sistemas de riego</li>
                    <li>Relación con el medio ambiente</li>
                    <li>Uso eficiente de los materiales</li>
                    <li>Manejo de los residuos generados por la construcción</li>
                    <li>Manejo de los residuos generados por los usuarios</li>
                    <li>Conectividad con transporte y servicios, entre muchos otros.</li>
                </ul>
            </div>
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-4 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-0 text-width-5 padding-fix">
                <p class="text-content">
                    La aplicación de la certificación ayuda a reducir los
                    costos de operación y mantención de las viviendas,
                    particularmente en temas de consumo energético y de
                    agua. Por otro lado, permite reducir los impactos
                    ambientales relacionados con el cambio climático. <br><br>
                    Toda esta información se entrega a los usuarios de
                    manera verificable y en un lenguaje sencillo,
                    explicando el rendimiento del proyecto en las distintas
                    categorías de sustentabilidad.<br><br>
                    Los usuarios de viviendas certificadas reciben un
                    manual con instrucciones para operar sus viviendas,
                    con el objetivo de mantener las características de
                    sustentabilidad a lo largo del tiempo.
                </p>
            </div>
        </div>
    </div>
    <div class="col-12 white-bg" style="overflow:hidden" bind:this={row4} id="about-section-3">
        <img src="./img/background-D.svg" alt="" class="background-left disabe-img" style="height:91vh !important;">
        <div class="row">
            <img bind:this={row4Image} src="./img/planta-paralaxC-2.png" alt="" class="about-base04-plant disabe-img" style="{row4Image ? `transform: translateX(${translate4Calculated/1200 - row4Image.getBoundingClientRect().width*0.75}px)` : ''} rotate(180deg)">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <h2 class="text-content title-content" style="margin-bottom:0"> BENEFICIOS </h2>
                <hr class="underline-content">
            </div >
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <p class="text-content">Esta herramienta es parte de las iniciativas nacionales para reducir los impactos ambientales del sector construcción y el efecto de Cambio Climático</p>
                <div class="img-set">
                    <img on:click={handleClickAboutCardOne} class="icon-size clickable {open === 1 ? 'selected-box' : ''}" src="./img/about/icono1-mundo1-D.svg" alt="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    <img on:click={handleClickAboutCardTwo} class="icon-size clickable middle-img {open === 2 ? 'selected-box' : ''}" src="./img/about/icono2-mundo1-D.svg" alt="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                    <img on:click={handleClickAboutCardThree} class="icon-size clickable {open === 3 ? 'selected-box' : ''}" src="./img/about/icono3-mundo1-D.svg" alt="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                </div>
                <div id="accordion" class="flex-arrow" style="margin-bottom:2vh;">
                      <div class="card" style="margin-bottom:1vh;">
                        <div on:click={handleClickArrow1} class="card-header clickable" id="headingOne" style="padding:0;" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          <h2 style="margin:0;padding:0;">
                            <button class="btn btn-link dropdown-header" style=" margin:0;" >
                                USUARIOS
                            </button>
                            <div class="sort-arrow" >
                                {#if up1 === false}<Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                {#if up1 === true}<Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                            </div>
                          </h2>
                        </div>
                        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                          <div class="card-body">
                              <ul class="list-content">
                                  <li>Acceso a información objetiva y verificable sobre el nivel de sustentabilidad de sus viviendas.</li>
                                  <li>Reducción de consumos energéticos, hídricos y contaminación ambiental.</li>
                                  <li>Ahorro en mantención de las viviendas y gastos comunes.</li>
                                  <li>Acceso a beneficios financieros.</li>
                              </ul>
                          </div>
                        </div>
                      </div>
                      <div class="card" style="margin-bottom:1vh;">
                        <div on:click={handleClickArrow2} class="card-header clickable" id="headingTwo" style="padding:0;" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                          <h2 style="margin:0;padding:0;">
                            <button class="btn btn-link dropdown-header" style="margin:0;" >
                                SECTOR PRIVADO
                            </button>
                            <div class="sort-arrow" >
                                {#if up2 === false}<Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                {#if up2 === true}<Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                            </div>
                          </h2>
                        </div>
                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                          <div class="card-body">
                              <ul class="list-content">
                                  <li>Valorización dentro de la oferta inmobiliaria, de proyectos que incorporen estándares de sustentabilidad, a través de una herramienta que cuenta con respaldo del sector público y privado.</li>
                                  <li>Creación y fortalecimiento de nuevos productos y servicios relacionados con la construcción sustentable.</li>
                              </ul>
                          </div>
                        </div>
                      </div>
                      <div class="card" style="margin-bottom:5vh;">
                        <div on:click={handleClickArrow3} class="card-header clickable" id="headingThree" style="padding:0;" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                          <h2 style="margin:0;padding:0;">
                            <button class="btn btn-link dropdown-header" style="margin:0;" >
                                SECTOR PÚBLICO
                            </button>
                            <div class="sort-arrow" >
                                {#if up3 === false}<Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                {#if up3 === true}<Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                            </div>
                          </h2>
                        </div>
                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                          <div class="card-body">
                              <ul class="list-content">
                                  <li>Definición de un estándar de sustentabilidad para la edificación residencial en Chile.</li>
                                  <li>Instrumento de fomento voluntario para colaborar con la mejora de la calidad del sector vivienda.</li>
                                  <li>Aporte al mejoramiento de la normativa.</li>
                                  <li>Propiciar la reducción de impactos ambientales provocados por la construcción.</li>
                              </ul>
                          </div>
                        </div>
                      </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 white-bg" style="overflow:hidden" id="about-section-4">
        <img src="./img/background-E.svg" alt="" class="background-right disabe-img" style="right: -30px;height: 108vh;max-height: 108vh;">
        <div class="row" style="margin-bottom:5%;">
            <img src="./img/about/logo-minvu-mundo1-E.svg" alt="" class="about-base05-logo disabe-img">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <h2 class="text-content title-content" style="margin-bottom:0"> QUIÉNES SOMOS </h2>
                <hr class="underline-content">
            </div>
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <p class="text-content" style="margin-bottom: 3vh;">
                    El desarrollo de la CVS es liderado por el Ministerio de
                    Vivienda y Urbanismo. En esta tarea, cuenta con el
                    apoyo de las siguientes instituciones:
                </p>
            </div>
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix" style="padding-right: 0;">
                <div id="accordionTwo" class="flex-arrow" style="margin:2vh 0;">
                      <div class="card" style="margin-bottom:1vh;">
                        <div on:click={handleClickArrow4} class="card-header clickable" id="headingListOne" style="padding:0;" data-toggle="collapse" data-target="#collapseListOne" aria-expanded="true" aria-controls="collapseListOne">
                          <h2 style="margin:0;padding:0;">
                            <button class="btn btn-link dropdown-header" style="color: rgb(0, 99, 175) !important; margin:0;" >
                                DIRECTORIO
                            </button>
                            <div class="sort-arrow" >
                                {#if up4 === false}<Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                {#if up4 === true}<Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                            </div>
                          </h2>
                        </div>
                        <div id="collapseListOne" class="collapse" aria-labelledby="headingListOne" data-parent="#accordionTwo">
                          <div class="card-body">
                              <ul class="list-content">
                                  <li>Ministerio de Energía</li>
                                  <li>Ministerio de Medio Ambiente</li>
                                  <li>Asociación de Desarrolladores Inmobiliarios</li>
                                  <li>Colegio de Arquitectos</li>
                                  <li>Instituto de la Construcción</li>
                                  <li>Certificación de Edificio Sustentable</li>
                                  <li>Cámara Chilena de la Construcción</li>
                                  <li>Centro Tecnológico para la Innovación en la Construcción (CTeC)</li>
                              </ul>
                          </div>
                        </div>
                      </div>
                      <div class="card" style="margin-bottom:5vh;">
                        <div on:click={handleClickArrow5} class="card-header clickable" id="headingListTwo" style="padding:0;" data-toggle="collapse" data-target="#collapseListTwo" aria-expanded="true" aria-controls="collapseListTwo">
                          <h2 style="margin:0;padding:0;">
                            <button class="btn btn-link dropdown-header" style="margin:0;" >
                                ADMINISTRADOR (CTeC)
                            </button>
                            <div class="sort-arrow" >
                                {#if up5 === false}<Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                {#if up5 === true}<Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                            </div>
                          </h2>
                        </div>
                        <div id="collapseListTwo" class="collapse" aria-labelledby="headingListTwo" data-parent="#accordionTwo">
                        <div class="card-body">
                            <p class="text-content" style="margin-top: 0;margin-bottom: 2vh;">El sistema es administrado por el Centro Tecnológico para la Innovación en la
                            Construcción (CTeC)</p>
                            <ul class="list-content">
                                <li>Tareas de administración</li>
                                <li>Registro de proyectos certificados</li>
                                <li>Registro de profesionales acreditados</li>
                                <li>Encargo de revisión de documentación</li>
                                <li>Mantención de Plataforma Técnica CVS</li>
                                <li>Regulación de capacitaciones y exámenes de conocimientos mínimos</li>
                                <li>Análisis de indicadores de sustentabilidad de los proyectos certificados</li>
                                <li>Entrega de certificados</li>
                                <li>Difusión del sistema</li>
                            </ul>
                        </div>
                        </div>
                      </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>

.background-right{
    right: 0;
    position: absolute;
    height: 100%;
    max-height: 100vh;
}

.background-left{
    left: 0;
    position: absolute;
    height: 100%;
    max-height: 100vh;
}

.about-base01-tree{
    position: absolute;
    bottom: 13%;
    left: 78%;
    height: 130%;
}

.about-base01-icon{
    position: absolute;
    bottom: 0%;
    left: 53%;
    height: 90%;
    width: 45%;
}

.about-base02-rooftop{
    position: relative;
    width: 100%;
    height: 200px;

}

.about-base03-house{
    position: absolute;
    bottom: 0%;
    height: 60%;
    left: 71%;
}

.about-base04-plant{
    position: absolute;
    left: 0;
    transform: scaleX(-1);
    height: 91vh;
}

.about-base05-logo{
    position: absolute;
    right: 2%;
    height: 35vh;
    top: 19vh;
}

.img-set{
    padding: 5vh;
    text-align: center;
}

.text-width-5{
    width: 50%;
}

.middle-img{
    margin: 0 15%;
}

.padding-fix{
    padding:0 8px;
}

@media (max-width: 1400px){
    .disabe-img {
        display:none;
    }
    .text-width-5{
        width: 100%;
    }
    .text-align{
        text-align: center;
    }
    .middle-img{
        margin: 0;
    }
    .padding-fix{
        padding:0 15px;
    }
}

.white-bg{
    background-color: white;
    overflow: hidden;
}

.dropdown-header{
    font-size: 20pt;
    line-height: 21pt;
    text-align: justify;
    color: rgb(0, 99, 175);
    font-family: 'suga-pro';
    padding: 6px 12px 6px 12px;
    white-space: pre-wrap;
}

.certification-icon-container{
    margin: 0 -10px;
    margin-bottom: 5vh;
    width: calc(100% + 20px);
}

.certification-icon-container .icon-size{
    margin: 10px;
}

.card-header{
    background-color: rgb(241,245,234);
}

.selected-box{
    padding: 5px;
    border: 1px solid #2dab66;
}

.sort-arrow {
    margin-left: auto;
}


.sort-arrow :global(.arrow-bot) {
    margin-bottom:13px;
    pointer-events: none;
}

.sort-arrow :global(.arrow-top) {
    margin-top:13px;
    pointer-events: none;
}

.flex-arrow .card-header h2{
    display: flex;
}

</style>
